export default __webpack_public_path__ + "static/media/Galaxy_08.fdfec8e4.png";